import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { formatNumber } from "@msuite/utils/numbers";
import { ExternalServicesTimeline } from "./external-services-timeline";

export function ExternalServices() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ContentCard
					title={t("general.overview")}
					icon={icon("Info")}
				>
					<DataGrid>
						<DataGrid.Row>
							<DataGrid.Label>{t("partners.settlement_sum")}</DataGrid.Label>
							<DataGrid.Value>{formatNumber(0, "currency")}</DataGrid.Value>
						</DataGrid.Row>
					</DataGrid>
				</ContentCard>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<ExternalServicesTimeline />
			</Panels.Panel>
		</Panels>
	);
}
